import MuiAutocomplete from "@mui/material/Autocomplete";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";

import SoftBox from "components/SoftBox";
import { TextField } from "../../../StyledComponents";
import { Chip } from "@mui/material";
import { formatFileSize } from "helpers/formatFileSize";

const Autocomplete = styled(MuiAutocomplete)(() => ({
  "& .MuiAutocomplete-endAdornment": {
    display: "none"
  }
}));

const TagFileListItem = ({
  fieldValue,
  handleRemoveFile,
  handleChooseFile,
  tagFileNames,
  allowEditWorkflow
}) => {
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  const handleAutocompleteChange = (e, value) => {
    handleRemoveFile(value);
  };

  const filterAutompleteOptions = (options, params) => {
    const filtered = options.filter((option) => {
      return option.toLowerCase().includes(params.inputValue?.toLowerCase());
    });
    return filtered;
  };

  return (
    <SoftBox width="100%">
      <span
        style={{
          float: "right",
          fontSize: "12px",
          marginRight: "10px",
          marginBottom: "10px",
          cursor: "pointer",
        }}
        onClick={() => handleChooseFile()}
      >
        Choose File
      </span>
      <Autocomplete
        freeSolo
        multiple
        value={tagFileNames && Array.isArray(tagFileNames) ? tagFileNames?.map((v) => v.value) : []}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                readOnly: true
              }
            }}
          />
        )}
        filterOptions={filterAutompleteOptions}
        onChange={handleAutocompleteChange}
        selectOnFocus
        renderValue={(value, getTagProps) =>
          value.map((option, index) => {
            const foundFieldValue = fieldValue?.find((field) => field.filename === option);

            return (
              <Chip
                {...getTagProps({ index })}
                key={option}
                label={
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "start",
                      marginRight: "4px"
                    }}
                  >
                    {option}
                    {!!foundFieldValue && (
                      <span style={{ marginTop: "4px", opacity: 0.7 }}>
                        {formatFileSize(foundFieldValue.size)}
                      </span>
                    )}
                  </span>
                }
              />
            );
          })
        }
        options={[]}
        open={false}
        disabled={isFlowActive || !allowEditWorkflow}
      />
    </SoftBox>
  );
};

export default TagFileListItem;
